import React from 'react'
import styles from '../../../CSS/main.css'

const Box: React.FC = ({ children }) => {
  return <div className={styles.QuickBox}>{children}</div>
}

export default Box
